const modalId = 'modal-editable-select2-values';
let activeSelect = null;

const textFor = (select, key, fallback) => select.data(key) || select.attr(`data-${key.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`)}`) || fallback;

const parseJson = (value) => {
	if(!value){
		return null;
	}
	if(typeof value === 'object'){
		return value;
	}

	try{
		return JSON.parse(value);
	}catch(error){
		return null;
	}
};

const standardValueSet = (select) => {
	const values = parseJson(select.data('standard-document-values') || select.attr('data-standard-document-values'));
	if(!Array.isArray(values)){
		return null;
	}

	return new Set(values.map((value) => value.toString()));
};

const currentValues = (select) => {
	const value = select.val();
	if(Array.isArray(value)){
		return value;
	}

	return value ? [value] : [];
};

const uniqueValues = (values) => {
	const seen = new Set();
	const normalized = [];

	values.forEach((value) => {
		const nextValue = (value || '').toString().trim();
		if(!nextValue || seen.has(nextValue)){
			return;
		}

		seen.add(nextValue);
		normalized.push(nextValue);
	});

	return normalized;
};

const ensureModal = () => {
	if($(`#${modalId}`).length){
		return $(`#${modalId}`);
	}

	$('body').append(`
		<div class="modal fade" id="${modalId}" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title"></h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div data-editable-select2-empty class="text-muted d-none"></div>
						<div data-editable-select2-values></div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal" data-editable-select2-cancel></button>
						<button type="button" class="btn btn-primary" data-editable-select2-save></button>
					</div>
				</div>
			</div>
		</div>
	`);

	const modal = $(`#${modalId}`);
	modal.on('click', '[data-editable-select2-remove-row]', function(){
		$(this).closest('[data-editable-select2-row]').remove();
		if(!modal.find('[data-editable-select2-row]').length){
			modal.find('[data-editable-select2-empty]').removeClass('d-none');
		}
	});

	modal.find('[data-editable-select2-save]').on('click', () => {
		if(!activeSelect || !activeSelect.length){
			modal.modal('hide');
			return;
		}

		const values = uniqueValues(modal.find('[data-editable-select2-input]').map((index, input) => $(input).val()).get());
		activeSelect.find('option').prop('selected', false);
		const standardSet = standardValueSet(activeSelect);
		values.forEach((value) => {
			let option = activeSelect.find('option').filter(function(){
				return $(this).val() === value;
			});

			if(!option.length){
				option = $('<option></option>').val(value).text(value);
				activeSelect.append(option);
			}

			option.prop('selected', true);
		});
		activeSelect.find('option').each(function(){
			const option = $(this);
			if(option.prop('selected')){
				return;
			}

			const optionValue = option.val();
			const normalizedOptionValue = optionValue === null || optionValue === undefined ? '' : optionValue.toString();
			const isStandardOption = standardSet ? standardSet.has(normalizedOptionValue) : option.data('editable-select2-original') === true;
			if(!isStandardOption){
				option.remove();
			}
		});

		activeSelect.val(values.length ? values : null).trigger('change');
		modal.modal('hide');
	});

	return modal;
};

const buildRows = (modal, select) => {
	const values = currentValues(select);
	const container = modal.find('[data-editable-select2-values]');
	const empty = modal.find('[data-editable-select2-empty]');
	const removeLabel = textFor(select, 'editableSelectedRemove', 'Remove');

	container.empty();
	empty.text(textFor(select, 'editableSelectedEmpty', 'No selection.'));

	if(!values.length){
		empty.removeClass('d-none');
		return;
	}

	empty.addClass('d-none');
	values.forEach((value) => {
		container.append(`
			<div class="input-group mb-2" data-editable-select2-row>
				<input type="text" class="form-control" data-editable-select2-input />
				<div class="input-group-append">
					<button type="button" class="btn btn-outline-danger" data-editable-select2-remove-row>${removeLabel}</button>
				</div>
			</div>
		`);
		container.find('[data-editable-select2-input]').last().val(value);
	});
};

const updateButtonState = (select, button) => {
	button.prop('disabled', currentValues(select).length === 0);
};

const initEditableSelect2 = (select = null) => {
	const selects = select || $('[data-editable-selected="true"]');
	if(!selects.length){
		return;
	}

	selects.each(function(){
		const element = $(this);
		if(element.data('editable-selected-initialized')){
			return;
		}

		element.data('editable-selected-initialized', true);
		element.find('option').each(function(){
			$(this).data('editable-select2-original', true);
		});
		const button = $(`<button type="button" class="btn btn-secondary btn-sm mt-2" data-editable-select2-open>${textFor(element, 'editableSelectedButton', 'Edit selection')}</button>`);
		element.closest('.form-group').append(button);

		button.on('click', () => {
			activeSelect = element;
			const modal = ensureModal();
			modal.find('.modal-title').text(textFor(element, 'editableSelectedTitle', 'Edit selection'));
			modal.find('[data-editable-select2-save]').text(textFor(element, 'editableSelectedSave', 'Save'));
			modal.find('[data-editable-select2-cancel]').text(textFor(element, 'editableSelectedCancel', 'Cancel'));
			buildRows(modal, element);
			modal.modal();
			setTimeout(() => {
				modal.find('[data-editable-select2-input]').first().focus();
			}, 200);
		});

		element.on('change.editable-select2', () => updateButtonState(element, button));
		updateButtonState(element, button);
	});
};

export default initEditableSelect2;
